
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/buttons",
      function () {
        return require("private-next-pages/components/buttons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/buttons"])
      });
    }
  